import create from "zustand";
import { persist } from "zustand/middleware";

interface LocalConfig {
  SomarSubcategoriasRelatorioDemonstrativo: boolean;
}

interface LocalConfigStore {
  config: LocalConfig;
  update: <K extends keyof LocalConfig>(prop: K, value: LocalConfig[K]) => void;
  reset: () => void;
}

const defaultConfig: LocalConfig = {
  SomarSubcategoriasRelatorioDemonstrativo: true,
};

export const useLocalConfig = create<LocalConfigStore>(
  persist(
    (set) => ({
      config: defaultConfig,
      update: (prop, value) => {
        set((state) => ({
          ...state,
          config: {
            ...state.config,
            [prop]: value,
          },
        }));
      },
      reset: () => {
        set((state) => ({
          ...state,
          config: defaultConfig,
        }));
      },
    }),
    {
      name: "@octopus-lc_1",
      getStorage: () => localStorage,
    }
  )
);
